<template>
  <div>
    <div class="row align-items-center my-5">
      <div class="col-lg-6 py-5">
        <div class="payment-hero__text" style="margin-top: 0">
          <h2 style="color: white" class="mb-4 font-weight-bold">
            ¡Próximo {{ datos[0].tipo_curso }}!
          </h2>
          <h4 style="color: white" class="font-weight-bold">
            {{ datos[0].nombre }}
          </h4>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="">
          <div
            class="img-fluid img-webinar-proximo my-5 my-mb-5"
            :style="`background-image:url(${datos[0].img});
                background-position: center center; background-repeat: no-repeat; background-size: cover;`"
          />
        </div>
        <div class="circulos-forum one"></div>
        <div class="circulos-forum two"></div>
        <div class="circulos-forum tree"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datos: Array,
  },
};
</script>

<style lang="scss" scoped>
.img-webinar-proximo {
  border-radius: 80% 50%;
  margin: 0 auto;
  display: block;
  height: 234px;
  width: 80%;
  @media (min-width: 768px) {
    height: 340px;
    width: 60%;
  }
  @media (min-width: 992px) {
    height: 250px;
    width: 70%;
  }
  @media (min-width: 1300px) {
    height: 300px;
    width: 70%;
  }
  @media (min-width: 1500px) {
    height: 340px;
    width: 60%;
  }
}
.text-hero .ql-align-justify {
  color: white !important;
}
.circulos-forum {
  position: absolute;
  border-radius: 50%;
  animation: jump infinite 2s;
  animation-direction: alternate;
  background-color: #f76b1c;
  background-image: radial-gradient(
    79.16% 79.16% at 55.39% 17.41%,
    #fff1be 0%,
    #ffcc0d 69.19%,
    #ffaa01 100%
  );
  &.one {
    width: 100px;
    height: 100px;
    left: 20%;
    top: 18px;
    @media (min-width: 992px) {
      width: 142px;
      height: 142px;
    }
  }

  &.two {
    width: 72.12px;
    height: 72.12px;
    left: 62%;
    bottom: 25px;
    margin-top: -8px;
    animation-delay: 1s;
  }
  &.tree {
    width: 36.52px;
    height: 36.52px;
    left: 74%;
    bottom: 105px;
    margin-top: -8px;
    animation-delay: 2s;
  }

  &--blue {
    background-color: #9c7af2;
    background-image: linear-gradient(-224deg, #9c7af2 0, #5e61e7 100%);
  }

  &--bg-blue {
    background: #5945e6;
    box-shadow: 0 2px 17px rgba(89, 69, 230, 0.27);
  }
  &--bg-green {
    background: #38cb89;
    box-shadow: 0 2px 17px rgba(89, 69, 230, 0.27);
  }
}

@keyframes jump {
  0% {
    transform: translateY(-10px) scale(0.9, 0.9);
  }
  100% {
    transform: translateY(10px) scale(1, 1);
  }
}
</style>